import { recordTrack } from '@saucelabs/sl-util-segmentio';
import { EVENT_CATEGORY } from '@saucelabs/sl-util-segmentio/lib/constants';

export const TRACKING_AREA = 'Automated';
export const TRACKING_SUB_AREA_DEFAULT = 'Builds';

export const BUILDS_EVENTS = Object.freeze({
  BUILDS_VIEWED: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate to Builds Detail Page',
  }),
  SELECT_TESTS_TAB: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Navigate to Tests Tab',
  }),
  SELECT_FAILURE_PATTERNS_TAB: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Navigate to Failure Patterns Tab',
  }),
  SELECT_PERFORMANCE_FILTER: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Performance Filter',
  }),
  TOGGLE_ROOT_CAUSE: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Toggle Failure Patterns',
  }),
  SELECT_LOAD_MORE: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Load More Failure Pattern Tests',
  }),
});

export const trackEvent = ({ category, name, metadata }) => {
  recordTrack(category, {
    subject_name: name,
    ...metadata,
  });
};

/**
 * trackEventWrapper for trackEvent function
 * @param {object} metadata
 * @returns {function} a function that accepts event and eventPayload as arguments
 * @param {object} event
 * @param {object} eventPayload
 * @returns {undefined}
 */
export const trackEventWrapper = (metadata) => (event, eventPayload) => {
  trackEvent({
    ...event,
    metadata: {
      ...(typeof eventPayload === 'object' ? eventPayload : null),
      ...metadata,
    },
  });
};
